<template>
  <div>
    <main class="main-content ">
      <div class="card">
        <div class="card-body">
          <h6 class="card-title">گزارش مدیریت</h6>
          <div class="row">
            <div class="col-6">
              <label for="">تاریخ شروع</label>
              <date-picker v-model="form.startDate" color="#007bff" label="شروع"></date-picker>
            </div>
            <div class="col-6">
               <label for="">تاریخ پایان</label>
              <date-picker v-model="form.finishDate" color="#007bff" label="پایان"></date-picker>
            </div>
          </div>
          <button class="btn btn-primary btn-block mt-5" @click="filter">اعمال فیلتر</button>

          <div class="table-responsive mt-5" v-if="data!=null">
            <projects :data="data">
            </projects>
            <paginations class="font" :count="pagination.count" :current="pagination.currentPage" v-on:pages="page"></paginations>
          </div>

          <div class="table-responsive mt-5" v-if="properties">
            <table class="table table-striped table-bordered">
              <thead>
                <tr>
                  <th>نام متریال</th>
                  <th v-for="(property, key , index) in properties" :key="index">{{property}}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(sums, name , index) in sumAttr" :key="index">
                  <td>{{name}}</td>
                  <td v-for="(sum, key , index) in sums" :key="index">{{sum}}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="table-responsive mt-5" v-if="statusesCount">
            <table class="table table-striped table-bordered">
              <thead>
                <tr>
                  <th v-for="(status, key , index) in statusesCount" :key="index">{{key}}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td v-for="(status, key , index) in statusesCount" :key="index">{{status}}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="d-flex justify-content-center">
            <div v-if="names!=null && values!=null" class="col-5 border m-4">
              <pie-chart :labels="names" :data="values" label="جدول وضعیت ها"/>
            </div>
          </div>

          <div v-if="properties!=null && chart!=null" class="row">
              <div class="col-5 border m-4" v-for="(property, num, index) in chart" :key="index">
                <bar-chart :labels="material" :data="property" :label="properties[index]"/>
              </div>
          </div>

        </div>
      </div>
    </main>
  </div>
</template>

<script>
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
import pagination from '@/mixins/pagination.js'
import paginations from '@/components/partials/paginations.vue'
import projects from '@/components/projects.vue'
import PieChart from '@/components/PieChart.vue'
import BarChart from '@/components/BarChart.vue'
// import { Chart } from 'frappe-charts'
export default {
  name: 'Report',
  mixins: [pagination],
  data () {
    return {
      data: null,
      getInStart: false,
      url: '/api/reports',
      type: 'post',
      what: 'form',
      form: {
        startDate: null,
        finishDate: null
      },
      statusesCount: null,
      names: null,
      values: null,
      properties: null,
      sumAttr: null,
      chart: null,
      material: null
    }
  },
  components: {
    datePicker: VuePersianDatetimePicker,
    paginations,
    projects,
    PieChart,
    BarChart
  },
  methods: {
    filter () {
      this.start()
      this.details()
    },
    details () {
      this.$send.submit('post', 'api/reports/details', this.form)
        .then(response => {
          this.statusesCount = response.statuses
          this.names = response.statusesNames
          this.values = response.statusCount
          this.properties = Object.values(response.properties)
          this.sumAttr = response.sumAttr
          this.chart = response.chart
          this.material = response.material
        })
    }
  }
}

</script>
<style>
 .font {
    font-family: "secondary-font", "primary-font", "segoe ui", "tahoma" !important;
  }
</style>
